import { render, staticRenderFns } from "./TotalRevenuePage.vue?vue&type=template&id=d5008b22&scoped=true"
import script from "./TotalRevenuePage.vue?vue&type=script&lang=js"
export * from "./TotalRevenuePage.vue?vue&type=script&lang=js"
import style0 from "./TotalRevenuePage.vue?vue&type=style&index=0&id=d5008b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5008b22",
  null
  
)

export default component.exports